import {AnyAction} from 'redux'
import {
  clearCheckout,
  editStep,
  nextFormClicked,
  nextStepAction,
  setBuyerDetails,
  setExpandedTicketIndex,
  setTicketDetails as setTicketDetailsAction,
  setUseBuyerDetails,
  setValidPaymentAdded,
} from '../actions/checkout'
import {RESERVE_TICKETS_OLD, makeReservation} from '../actions/reservation'
import {CHECKOUT_STEPS} from '../constants/constants'
import {CheckoutState} from '../types/state'

export const defaultCheckoutState: CheckoutState = {
  useBuyerDetails: false,
  currentStep: CHECKOUT_STEPS[0],
  validPaymentAdded: false,
  buyerDetails: null,
  ticketsDetails: [],
  ticketsDetailsValidity: [],
  expandedTicketIndex: 0,
}

export const checkout = (state = defaultCheckoutState, action: AnyAction): CheckoutState => {
  switch (action.type) {
    case setBuyerDetails.toString():
      if (setBuyerDetails.match(action)) {
        const buyerDetails = action.payload

        if (state.useBuyerDetails) {
          const ticketsDetails = [...state.ticketsDetails]

          ticketsDetails[0] = {
            ...ticketsDetails[0],
            ...buyerDetails,
          }
          return {...state, buyerDetails, ticketsDetails}
        } else {
          return {
            ...state,
            buyerDetails,
          }
        }
      }

      return state
    case setTicketDetailsAction.toString():
      return setTicketDetails(state, action as ReturnType<typeof setTicketDetailsAction>)
    case setValidPaymentAdded.toString():
      return {
        ...state,
        validPaymentAdded: action.payload,
      }
    case setUseBuyerDetails.toString():
      return handleUseBuyerDetails(state, action)
    case nextStepAction.toString():
      return {
        ...state,
        currentStep: action.payload,
      }
    case editStep.toString():
      const {step, validPaymentAdded} = action.payload
      return {
        ...state,
        currentStep: step,
        validPaymentAdded,
      }
    case nextFormClicked.toString():
      return {
        ...state,
        expandedTicketIndex: state.expandedTicketIndex + 1,
      }
    case setExpandedTicketIndex.toString():
      return {
        ...state,
        expandedTicketIndex: action.payload,
      }
    case RESERVE_TICKETS_OLD.SUCCESS: {
      const ticketsDetailsValidity = action.payload.reservations.reduce(
        (acc, ticketReservation) => [...acc, ...Array(ticketReservation.quantity).fill(false)],
        [],
      )
      return {...state, ticketsDetailsValidity}
    }
    case makeReservation.fulfilled.toString(): {
      const reservations = action.payload.reservations || []
      const ticketsDetailsValidity = reservations.reduce(
        (acc, ticketReservation) => [...acc, ...Array(ticketReservation.quantity || 0).fill(false)],
        [],
      )

      return {...state, ticketsDetailsValidity}
    }
    case clearCheckout.toString():
      return defaultCheckoutState
    default:
      return state
  }
}

const handleUseBuyerDetails = (state: CheckoutState, action: AnyAction): CheckoutState => {
  if (setUseBuyerDetails.match(action)) {
    const {
      buyerDetails: {firstName, lastName, email},
    } = state
    const {useBuyerDetails, ticketIndex = 0} = action.payload

    const shouldUseBuyerDetails = useBuyerDetails
    const buyerDetails = shouldUseBuyerDetails
      ? {firstName, lastName, email}
      : {firstName: null, lastName: null, email: null}
    const ticketsDetails = [...state.ticketsDetails]

    ticketsDetails[ticketIndex] = {
      ...ticketsDetails[ticketIndex],
      ...buyerDetails,
    }

    return {
      ...state,
      ticketsDetails,
      useBuyerDetails: shouldUseBuyerDetails,
    }
  }
}

const setTicketDetails = (state: CheckoutState, action: ReturnType<typeof setTicketDetailsAction>) => {
  const ticketsDetails = [...state.ticketsDetails]
  const ticketsDetailsValidity = [...state.ticketsDetailsValidity]

  ticketsDetails[action.payload.index] = action.payload.details
  ticketsDetailsValidity[action.payload.index] = action.payload.valid

  return {
    ...state,
    ticketsDetails,
    ticketsDetailsValidity,
  }
}
